import { QuestionnaireContext } from 'components/Assessment/QuestionnaireContext'
import { useContext } from 'react'

export const useFormulaSheet = () => {
  const { grade } = useContext(QuestionnaireContext)
  let formulaSheetUrl = ''
  switch (grade) {
    case 6:
      formulaSheetUrl = '/G6-Formula-Sheet_2024_ADA_OSTP.pdf'
      break
    case 7:
      formulaSheetUrl = '/G7-Formula-Sheet_2024_ADA_OSTP.pdf'
      break
    case 8:
      formulaSheetUrl = '/G8-Formula-Sheet_2024_ADA_OSTP.pdf'
      break
    default:
      break
  }

  return formulaSheetUrl
}
